//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDeliveryList', {
//        templateUrl: 'views/components/views/batchDeliveryList/batchDeliveryList.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'batchDeliveryListService', 'shipmentContainerService', 'logisticService', 'rememberService', function (stateService, utilityService, batchDeliveryListService, shipmentContainerService, logisticService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                stockplace_id: '',
//                stocklocation_keyno: ''
//            };

//            vm.model = {
//                bgBatchDelivery: {
//                    selected: 'batchdelivery_in_progress',
//                    buttons: [
//                        { id: 'batchdelivery_in_progress', label: 'batchdelivery_in_progress', color: 'primary', onClick: () => vm.model.bgBatchDelivery.selected = 'batchdelivery_in_progress' },
//                        { id: 'batchdelivery_verified', label: 'batchdelivery_verified', color: 'primary', onClick: () => vm.model.bgBatchDelivery.selected = 'batchdelivery_verified' },
//                        { id: 'batchdelivery_finished', label: 'batchdelivery_finished', color: 'primary', onClick: () => vm.model.bgBatchDelivery.selected = 'batchdelivery_finished' }
//                    ]
//                },
//                stockLocationButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('stocklocation_keyno') }
//                ],
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlaces: [],
//                selectListStockLocations: [],
//                itemsListBatchDeliveries: [],
//                lockedCreateNew: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await batchDeliveryListService.getSetting())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
//            }

//            async function loadStockLocations() {
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;
                
//                return vm.model.selectListStockLocations = await shipmentContainerService.listStockLocations({
//                    stockzoneclass_keyno: '1',
//                    stockplace_id: vm.model.setting.stockplace_id,
//                    add_all: '1'
//                });
//            };

//            async function loadBatchDeliveries() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stocklocation_keyno, true) !== true) return;

//                return vm.model.itemsListBatchDeliveries = await batchDeliveryListService.listBatchDeliveries({
//                    status: vm.model.bgBatchDelivery.selected,
//                    businessco_no: vm.model.setting.businessco_no,
//                    stockplace_id: vm.model.setting.stockplace_id,
//                    stocklocation_keyno: vm.model.setting.stocklocation_keyno
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region RETRIEVE LAST STATUS FUNCTION

//            function retrieveLastStatus() {
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

//                let variableName = `batchdelivery_list.stocklocation_keyno.stockplace_id=${vm.model.setting.stockplace_id}`;

//                return rememberService.getLastStatus(variableName).then((response) => {
//                    if (response[0].variablevalue === '') {
//                        vm.model.setting.stocklocation_keyno = '0';
//                    } else {
//                        vm.model.setting.stocklocation_keyno = response[0].variablevalue;
//                    }
//                });
//            }

//            // #endregion RETRIEVE LAST STATUS FUNCTION

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'stockplace_id':
//                            variableNames[key] = stateService.getCurrentName() + '.' + key + '.' + vm.model.setting.businessco_no;
//                            break;
//                        case 'stocklocation_keyno':
//                            variableNames[key] = stateService.getCurrentName() + '.' + key + '.' + 'stockplace_id' + '=' + vm.model.setting.stockplace_id;
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'stockplace_id':
//                    case 'stocklocation_keyno':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'stocklocation_keyno':
//                        vm.model.setting.stocklocation_keyno = '0';

//                        if (vm.model.setting.stocklocation_keyno === '0') {
//                            Promise.all([
//                                rememberFunc('stocklocation_keyno')
//                            ]).then(() => {
//                                loadBatchDeliveries();
//                                Promise.resolve();
//                            });
//                        }
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region CREATE NEW BUTTON

//            vm.createNewBatchDelivery = function () {
//                vm.model.lockedCreateNew = true;

//                batchDeliveryListService.createBatchDelivery({
//                    businessco_no: vm.model.setting.businessco_no,
//                    stockplace_id: vm.model.setting.stockplace_id,
//                    stocklocation_keyno: vm.model.setting.stocklocation_keyno
//                }).then((response) => {
//                    vm.model.lockedCreateNew = false;
//                    stateService.go(response[0].webpagename, response[0].parms);
//                }, () => vm.model.lockedCreateNew = false);
//            }

//            // #endregion CREATE NEW BUTTON

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgBatchDelivery = function (value) {
//                vm.model.bgBatchDelivery.selected = value;

//                loadBatchDeliveries();
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

//                        vm.model.setting.businessco_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

//                        loadStockPlaces();
//                        break;
//                    case 'stockplace_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

//                        vm.model.setting.stockplace_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('stockplace_id'),
//                            loadStockLocations(),
//                            retrieveLastStatus()
//                        ]).then(() => {
//                            loadBatchDeliveries();
//                            Promise.resolve();
//                        });

//                        break;
//                    case 'stocklocation_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.stocklocation_keyno) !== true) return;

//                        vm.model.setting.stocklocation_keyno = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.stocklocation_keyno, true) !== true) return;

//                        Promise.all([
//                            rememberFunc('stocklocation_keyno')
//                        ]).then(() => {
//                            loadBatchDeliveries();
//                            Promise.resolve();
//                        });
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ANGULAR LIFECYCLE

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();

//                return Promise.all([
//                    loadStockPlaces(),
//                    loadStockLocations()
//                ]).then(() => {
//                    loadBatchDeliveries();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ANGULAR LIFECYCLE

//        }]
//    });
//})();
